<script>
import { mapState, mapActions } from "vuex";
import ClientFactory from "@/api/ClientFactory";
import moment from "moment";
const dropdownsApi = ClientFactory.get("dropdowns");
const paysApi = ClientFactory.get("pays");
import Datepicker from "vuejs-datepicker";
import { vi } from "vuejs-datepicker/dist/locale";
import UploadFile from '../../../components/files/Upload.vue';
import { VueGoodTable } from "vue-good-table";
export default {
    components: {
        Datepicker,
        UploadFile,
        VueGoodTable
    },
    data: () => ({
        datepicker: {
            lang: {
                vi: vi,
            },
        },
        body: {
            report_name: "",
            report_type: 2,
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1,
            form_name:"",
            circulars_number: "",
            public_date: new Date(),
            localbudget_pay: "",
            unit_localbudget: "triệu đồng",
            other_pay: "",
            unit_other: "triệu đồng",
            note: "",
            unit: "triệu đồng"

        },
        years:[],
        dialog: {
            active: false,
            type: ""
        },
        attachments: {
            file_statistical: [],
            file_other: [],
            file_report: []
        },
        attachmentsFilesName: {
            file_statistical: [],
            file_other: [],
            file_report: []
        },
        file_data: [],
        dataBody:[{
            month: 1
        }]
    }),
    methods: {
        ...mapActions("ui", ["loading", "closeLoading", "notify"]),
        async getReport(id) {
            this.loading(this.$vs);
            const response = await paysApi.get_pay({id: id });
            await this.getAttachments(id);
            if (response.status == "success") {
                ({  id: this.body.id,
                    report_name: this.body.report_name, 
                    report_type: this.body.report_type,
                    year: this.body.year,
                    month: this.body.month,
                    form_name: this.body.form_name,
                    circulars_number: this.body.circulars_number,
                    public_date: this.body.public_date,

                    localbudget_pay: this.body.localbudget_pay,
                    unit_localbudget: this.body.unit,
                    other_pay: this.body.other_pay,
                    unit_other: this.body.unit,

                    note: this.body.note,
                    status: this.body.status
                } = response.data[0]);
                
                this.body.unit = Number(this.body.unit) || 2; // Chuyển đổi đơn vị sang kiểu số để hiển thị. 1: triệu đồng, 2: tỷ đồng
                this.body.public_date = moment(this.body.public_date, "DD/MM/YYYY").toDate()
            }
            this.closeLoading();
        },
        async getAttachments(id) {
            const result = await paysApi.get_pay_file({
                report_id: id,
                report_type: this.body.report_type
            });

            this.file_data = result.data.map(file => {
                return {
                    file_id: file.file_id,
                    file_type_id: file.file_type_id,
                    file_type_name: file.file_type_name,
                    file_name: file.file_name,
                    file_url: file.file_path,
                }
            })
        },
        /**
         * Lọc những file theo kiểu file: file báo cáo, file thống kê hay file khác từ mảng tổng các files.
         */
        getListFileAsType(files, type) {
            return files.filter(f => f.file_type_id === type).map(item=> item.file_id)
        },
        displayUploadDialog(type) {
            this.dialog.active = true;
            this.dialog.type = type;
        },
        uploadDone() {
            this.dialog.active = false;
            switch(this.dialog.type) {
                case "file_report":
                    this.attachments.file_report = this.$refs.uploadDialog.fileIds.map(f=> parseInt(f));
                    this.attachmentsFilesName.file_report = this.$refs.uploadDialog.fileRecordsForUpload.map(item => {
                        return item.file.name
                    })
                    break;
                case "file_statistical":
                    this.attachments.file_statistical = this.$refs.uploadDialog.fileIds.map(f=> parseInt(f));
                    this.attachmentsFilesName.file_statistical = this.$refs.uploadDialog.fileRecordsForUpload.map(item => {
                        return item.file.name
                    })
                    break;
                case "file_other":
                    this.attachments.file_other = this.$refs.uploadDialog.fileIds.map(f=> parseInt(f));
                    this.attachmentsFilesName.file_other = this.$refs.uploadDialog.fileRecordsForUpload.map(item => {
                        return item.file.name
                    })
                    break;
                default:
                    break
            }
        },
        removeFile(file) {
            this.file_data = this.file_data.filter(f => f.file_id !== file.file_id)
        },
        async update() {
            await this.$validator.validateAll();
            if(this.errors.items.length > 0) {
                return this.notify({
                    error: true,
                    title:"Đã có lỗi", 
                    text: this.errors.items[0].msg,
                });
            }
            const public_date = moment(this.body.public_date).format("DD/MM/YYYY");

            const attachmentFiles = {
                file_statistical: this.getListFileAsType(this.file_data, 2).concat(this.attachments.file_statistical),
                file_other: this.getListFileAsType(this.file_data, 3).concat(this.attachments.file_other),
                file_report: this.getListFileAsType(this.file_data, 1).concat(this.attachments.file_report),
            }

            if(attachmentFiles.file_statistical.length == 0) {
                return this.notify({
                    error: true,
                    text: 'Số liệu thống kê là bắt buộc',
                });
            }
            if(attachmentFiles.file_report.length == 0) {
                return this.notify({
                    error: true,
                    text: 'Văn bản/báo cáo là bắt buộc',
                });
            }

            this.loading(this.$vs);
            let result = await paysApi.update_pay({
                ...this.body,
                unit_localbudget: this.body.unit,
                unit_other: this.body.unit,
                public_date
            });
            let file_response = await paysApi.update_pay_file({
                ...attachmentFiles,
                report_id: this.body.id
            });
            if(file_response.status === "success") {
                // clear attachments
                this.attachments = {
                    file_statistical:[],
                    file_other: [],
                    file_report: []
                }
            }
            
            this.closeLoading();
            if (typeof result.error !== "undefined" || result.data.status === "failed" ||  result.status === "failed" ) {
                this.notify({
                    error: true,
                    text: result.error || result.message,
                });
            } else {
                this.notify({
                    text: result.data[0].error_message,
                });
                // go back
                this.$router.go(-1);
            }
        }
    },
    computed: {
        ...mapState("auth", ["AppActiveUser"]),
        typeReports() {
            return [
                {
                    label: "Thu ngân sách",
                    value: 1,
                },
                {
                    label: "Chi ngân sách",
                    value: 2,
                },
            ]
        },
        months() {
            return [
                {
                    label: "Tháng 1",
                    value: 1,
                },
                {
                    label: "Tháng 2",
                    value: 2,
                },
                {
                    label: "Tháng 3",
                    value: 3,
                },
                {
                    label: "Tháng 4",
                    value: 4,
                },
                {
                    label: "Tháng 5",
                    value: 5,
                },
                {
                    label: "Tháng 6",
                    value: 6,
                },
                {
                    label: "Tháng 7",
                    value: 7,
                },
                {
                    label: "Tháng 8",
                    value: 8,
                },
                {
                    label: "Tháng 9",
                    value: 9,
                },
                {
                    label: "Tháng 10",
                    value: 10,
                },
                {
                    label: "Tháng 11",
                    value: 11,
                },
                {
                    label: "Tháng 12",
                    value: 12,
                },
            ]
        },
        file_columns() {
            return [
                {
                    label: "Loại tệp báo cáo",
                    field: "file_type_name",
                    thClass: "emu-vgt-thead-th",
                    tdClass: "emu-vgt-tbody-td",
                    width: "200px",
                },
                {
                    label: "Tên tệp tin",
                    field: "file_name",
                    thClass: "emu-vgt-thead-th",
                    tdClass: "emu-vgt-tbody-td",
                },
                {
                    label: "Hành động",
                    field: "action",
                    thClass: "emu-vgt-thead-th text-center width-status",
                    tdClass: "emu-vgt-tbody-td text-center width-status",
                    width: "100px",
                },
            ]
        },
        columns() {
            return [
                {
                    label: "Tên báo cáo *",
                    field: "report_name",
                    thClass: "text-center",
                    width: "200px",
                },
                {
                    label: "Tháng *",
                    field: "month",
                    thClass: "text-center",
                    width: "130px",
                },
                {
                    label: "Năm *",
                    field: "year",
                    thClass: "text-center",
                    width: "100px",
                },
                // {
                //     label: "Thông tư *",
                //     field: "circulars_number",
                //     thClass: "text-center",
                //     tdClass: "text-center",
                //     width: "120px",
                // },
                // {
                //     label: "Biểu mẫu",
                //     field: "form_name",
                //     thClass: "text-center",
                //     tdClass: "text-center",
                //     width: "120px",
                // },
                {
                    label: "Chi cân đối NS địa phương",
                    field: "localbudget_pay",
                    thClass: "text-center",
                    tdClass: "text-center",
                    width: "150px",
                },
                {
                    label: "Chi CT MTQG,DA,nhiệm vụ khác",
                    field: "other_pay",
                    thClass: "text-center",
                    tdClass: "text-center",
                    width: "150px",
                },
            ]
        },
        units() {
            return [
                {
                label: "triệu đồng",
                value: 1,
                },
                {
                label: "tỷ đồng",
                value: 2,
                },
            ]
        }
    },
    async created() {
        this.years = await dropdownsApi.get(dropdownsApi.type.YEARS);
        const reportId = this.$route.params.id || -1;
        this.body.id = reportId;
        this.getReport(reportId);
    },
    destroyed() {
        this.closeLoading();
    }
    
}
</script>

<template>
    <div class="edit-pay-container">
        <CCard title="Thu ngân sách" class="mb-12">
            <CCardHeader class="pt-1 pb-1">
                <span class="card-header-title">Cập nhật báo cáo chi ngân sách</span>
            </CCardHeader>
            <CCardBody>
                <CRow>
                    <CCol sm="3" class="mb-2">
                        <CSelect
                            label="Loại báo cáo (*)"
                            v-validate="'required'"
                            name="Loại báo cáo"
                            :options="typeReports"
                            :value.sync="body.report_type"
                            disabled="true"
                        />
                    </CCol>
                    <CCol sm="3" class="mb-2">
                        <span>Ngày công bố *</span>
                        <b-form-datepicker
                        id="datepicker"
                        v-model="body.public_date"
                        class="mb-2 mt-2"
                        locale="vi"
                        placeholder="Ngày công bố"
                        :date-format-options="{
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                        }"
                        :hide-header="true"
                        label-help=""
                        :value-as-date="true"
                        />
                    </CCol>
                    <CCol sm="2" class="mb-2">
                        <CSelect
                            label="Đơn vị"
                            :options="units"
                            :value.sync="body.unit"
                        />
                    </CCol>
                </CRow>

                <vue-good-table
                    :columns="columns"
                    :rows="dataBody"
                    compactMode
                    :pagination-options="{
                        
                    }"
                    :search-options="{
                        enabled: false,
                        placeholder: 'Tìm kiếm',
                    }"
                    :sort-options="{
                        enabled: false,
                    }"
                >
                    <template slot="table-row" slot-scope="props">
                        <div v-if="props.column.field === 'report_name'">
                            <CInput
                            placeholder="Điền tên báo cáo thu ngân sách"
                            name="Tên báo cáo"
                            v-validate="'required'"
                            v-model="body.report_name"
                            />
                        </div>
                        <div v-else-if="props.column.field === 'month'">
                            <CSelect
                                v-validate="'required'"
                                name="Tháng"
                                :options="months"
                                :value.sync="body.month"
                            />
                        </div>
                        <div v-else-if="props.column.field === 'year'">
                            <CSelect
                                v-validate="'required'"
                                :options="years"
                                name="Năm"
                                :value.sync="body.year"
                            />
                        </div>
                        <!-- <div v-else-if="props.column.field === 'circulars_number'">
                            <CInput
                            v-validate="'required'"
                            placeholder="VD: TT343"
                            name="Số thông tư"
                            v-model="body.circulars_number"
                            />
                        </div>
                        <div v-else-if="props.column.field === 'form_name'">
                            <CInput placeholder="Số biểu mẫu" v-model="body.form_name" />
                        </div> -->
                        <div v-else-if="props.column.field === 'localbudget_pay'">
                            <CInput
                                name="Chi cân đối NS địa phương"
                                v-validate="'required|decimal'"
                                v-model="body.localbudget_pay"
                            />
                        </div>
                        <div v-else-if="props.column.field === 'other_pay'">
                        <CInput
                            name="Chi CT MTQG,DA, nhiệm vụ khác"
                            v-validate="'required|decimal'"
                            v-model="body.other_pay"
                            />
                        </div>
                    </template>
                </vue-good-table>
                <CRow class="mt-4">
                    <CCol sm="12" class="mb-2"><span>File đính kèm</span></CCol>
                </CRow>
                <vue-good-table
                        :columns="file_columns"
                        :rows="file_data"
                        :sort-options="{
                            enabled: false,
                        }"
                        class="file-table"
                    >
                        <div slot="emptystate" style="margin-top: 10px; margin-bottom: 10px">
                            Không có dữ liệu
                        </div>
                        <template slot="table-row" slot-scope="props">
                            <div v-if="props.column.field === 'action'" class="row">
                                <vs-button v-b-tooltip.hover transparent circle icon>
                                    <CLink :href="props.row.file_url" target="_blank">
                                        <span><i class="bx bx-download"></i></span>
                                    </CLink>
                                </vs-button>
                                <vs-button v-b-tooltip.hover transparent circle icon danger @click="removeFile(props.row)"><i class='bx bx-x'></i></vs-button>
                            </div>
                        </template>
                </vue-good-table>
                <CRow class="mb-2 mt-4">
                    <CCol sm="4" class="ml-0">
                        <span>Văn bản/báo cáo (*)</span>
                        <vs-button class="ml-0" square danger @click="displayUploadDialog('file_report')"><i class="bx bx-cloud-upload"></i> &nbsp; Chọn files</vs-button>
                        <span v-if="this.attachments.file_report.length > 0" style="color: #2eb85c" class="small">Đã tải lên {{this.attachments.file_report.length}} tệp tin</span>
                    </CCol>
                    <CCol sm="4">
                        <span>Số liệu thống kê (*)</span>
                        <vs-button class="ml-0" square danger @click="displayUploadDialog('file_statistical')"><i class="bx bx-cloud-upload"></i> &nbsp; Chọn files</vs-button>
                        <span v-if="this.attachments.file_statistical.length > 0" style="color: #2eb85c;" class="small">Đã tải lên {{this.attachments.file_statistical.length}} tệp tin</span>
                    </CCol>
                    <CCol sm="4">
                        <span>Tệp đính kèm khác</span>
                        <vs-button class="ml-0" square danger @click="displayUploadDialog('file_other')"><i class="bx bx-cloud-upload"></i> &nbsp; Chọn files</vs-button>
                        <span v-if="this.attachments.file_other.length > 0" style="color: #2eb85c;" class="small">Đã tải lên {{this.attachments.file_other.length}} tệp tin</span>
                    </CCol>
                </CRow>
                <CRow class="mb-2 mt-4">
                    <CCol sm="12">
                        <CTextarea
                        multiple="true"
                        label="Ghi chú"
                        placeholder="Điền nội dung ghi chú cho báo cáo"
                        v-model="body.note"
                        />
                    </CCol>
                </CRow>
            </CCardBody>
            <CCardFooter>
                <CRow>
                    <CCol sm="12" class="center">
                        <vs-button square class="custom_btn_search" @click="() => {this.$router.go(-1);}"><i class="bx bx-left-arrow-alt"></i> &nbsp; Quay lại</vs-button>
                        <vs-button square @click="update"><i class="bx bx-save"></i> &nbsp; Cập nhật</vs-button>
                    </CCol>
                </CRow>
            </CCardFooter>
        </CCard>
        <vs-dialog prevent-close width="600px" scroll overflow-hidden v-model="dialog.active">
            <template #header>
                <h4 class="not-margin">
                <b>Tải lên</b>
                </h4>
            </template>
            <UploadFile ref="uploadDialog"/>
            <template #footer>
                <div class="con-footer flex flex-end">
                    <vs-button square success @click="$refs.uploadDialog.uploadFiles()"><i class="bx bx-cloud-upload"></i> &nbsp; Bắt đầu tải</vs-button>
                    <vs-button square danger @click="uploadDone"><i class="bx bx-save"></i> &nbsp; Xong</vs-button>
                </div>
            </template>
        </vs-dialog>
    </div>
</template>
<style lang="scss">
.edit-pay-container {
    .file-table {
        .vgt-responsive {
            overflow-x: inherit;
        }
        table.vgt-table td {
            vertical-align: inherit;
            padding: 0em 0.75em 0em 0.75em;
        }
        table.vgt-table th {
            font-weight: normal;
        }
    }
    
}
    
</style>